/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import SignIn from '@/components/SignIn';
import SearchEvents from '@/components/events/Search';
import CreateEvents from '@/components/events/Create';
import GetEvent from '@/components/events/Home';

import { AmplifyEventBus } from 'aws-amplify-vue';

Vue.use(Router);

const router = new Router({
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/signin',
      name: 'Sign In',
      component: SignIn,
      meta: {
        requiresAuth: false,
      },
      beforeEnter: (to, from, next) => {
        AmplifyEventBus.$emit('authState', 'signIn');
        next();
      },
    },
    {
      path: '/signup',
      name: 'Sign Up',
      component: SignIn,
      meta: {
        requiresAuth: false,
      },
      beforeEnter: (to, from, next) => {
        AmplifyEventBus.$emit('authState', 'signUp');
        next();
      },
    },
    {
      path: '/search/event',
      name: 'Search Events',
      component: SearchEvents,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/create/event',
      name: 'Create Event',
      component: CreateEvents,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/event/:eventId/edit',
      name: 'Edit Event',
      component: GetEvent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/event/:eventId',
      name: 'Get Event',
      component: GetEvent,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      next();
    }).catch((e) => {
      next({
        path: '/signin',
        query: {
          from: to.fullPath,
        },
      });
    });
  }
  next();
});

export default router;